// @ts-nocheck

import palette from '../palette';

export const Scoreboards = {
  wrapperBackground: palette.transparent,
  color: palette.white,
  scorersColor: palette.bluegrey100,
  scoresColor: palette.bluegrey200,
  darkColor: palette.black,
  secondaryScoreColor: palette.neutralgrey450,
  psoScoreColor: palette.yellowwinamax200,
  psoScoreBackground: palette.bluegrey800,
  redCardBackground: palette.red200,

  scorerIconBackground: '#1a264d',
  scorerIconColor: palette.blueinfo350,

  serverIconBackground: palette.yellowwinamax450,
  setScoreColumn: palette.bluegrey200,
  lastSetScoreColumn: palette.yellowwinamax450,
  gameScoreRow: palette.yellowwinamax450,
  gameScoreColor: palette.yellowwinamax450,
  absoluteGreyBackground: palette.bluegrey800,
  headerColor: palette.bluegrey850,
  gameScoreRowBackground: palette.bluegrey800,
};
